<template>
  <div class="row">
    <div class="small-12 columns">
      <div class="row">
        <div class="small-3 columns">Institution</div>
        <div class="small-9 columns">
          <input
            v-model="institution"
            type="text"
            class="input-box-course-creators"
          />
        </div>
      </div>
    </div>
    <div class="small-12 columns">
      <div class="row">
        <div class="small-3 columns">Code</div>
        <div class="small-9 columns">
          <input v-model="code" type="text" class="input-box-course-creators" />
        </div>
      </div>
    </div>
    <div class="small-12 columns">
      <button @click="editInstitution">Edit Institution</button>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      institution: undefined,
      code: undefined,
    }
  },
  mounted() {
    this.axios({
      method: "get",
      url: `${siteConfig.siteURL}institution/${this.$route.params.id}`,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "x-access-token": localStorage.token,
      },
      data: { name: this.institution, government_code: this.code },
    }).then(res => {
      this.institution = res.data.name
      window.pageTitle = `Edit - ${this.institution}`
      this.code = res.data.government_code
    })
  },
  methods: {
    editInstitution() {
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}institution/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
        data: { name: this.institution, government_code: this.code },
      }).then(() => {
        this.$router.push("/institution/")
      })
    },
  },
}
</script>
